__turbopack_context__.v({
  "bid-pulse": "bids-module__Z6GOtG__bid-pulse",
  "bids-rise": "bids-module__Z6GOtG__bids-rise",
  "bids-settle": "bids-module__Z6GOtG__bids-settle",
  "enter": "bids-module__Z6GOtG__enter",
  "tile": "bids-module__Z6GOtG__tile",
  "tileEnter": "bids-module__Z6GOtG__tileEnter",
});
